import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { User } from '../../../../core';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  currentUser: User;
  changePWForm: FormGroup;
  changeInfoForm: FormGroup;
  avatarUrl = 'http://themenate.com/applicator/dist/assets/images/avatars/thumb-13.jpg';
  pwdNotMatch = false;
  changePwdError = false;
  changePwdErrorMsg = 'An error has occurred! The password could not be changed.';
  changePwdSuccees = false;

  constructor(
    private fb: FormBuilder,
  ) {
  }

  ngOnInit(): void {
    this.changePWForm = this.fb.group({
      currentPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(50)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(50)]]
    });

    this.changeInfoForm = this.fb.group({
      login: [null, [Validators.required]],
      email: [null, [Validators.required]],
      firstName: [],
      lastName: [],
      phone: [],
    });

  }

}
